import { ApplicationConfig, ErrorHandler, isDevMode } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@env/environment';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import * as Sentry from '@sentry/angular';

import { REQUEST, requestFactory } from '@personal-area/common';
import { provideWebVitals } from '@personal-area/shared/web-vitals';

import { appProviders } from './app.module';

export const appBrowserConfig: ApplicationConfig = {
  providers: [
    ...appProviders,
    {
      // The server provides these in main.server
      provide: REQUEST,
      useFactory: requestFactory,
    },
    environment.isStage || isDevMode()
      ? provideStoreDevtools({ connectInZone: true, trace: true })
      : [],
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideWebVitals(environment.webVitals),
  ],
};
